export const selectAllCategories = (state) => state.mainReducer.categories;
